import { render, staticRenderFns } from "./RuStoreSettings.vue?vue&type=template&id=63648b3e&"
import script from "./RuStoreSettings.vue?vue&type=script&lang=ts&"
export * from "./RuStoreSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports